import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { TESTIMONIALS } from "@/data/site";
import { EASE } from "@/lib/api";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const n = TESTIMONIALS.length;
  const t = TESTIMONIALS[i];

  useEffect(() => {
    const id = setTimeout(() => setI((v) => (v + 1) % n), 8000);
    return () => clearTimeout(id);
  }, [i, n]);

  return (
    <section data-testid="testimonials-section" className="mx-auto max-w-[1440px] px-5 md:px-10 py-24 md:py-40">
      <div className="grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-3">
          <p className="eyebrow">Kind Words</p>
          <p className="font-display text-[7rem] leading-none text-gold mt-4 select-none">“</p>
          <div className="flex items-center gap-4 mt-2">
            <button data-testid="testimonial-prev" onClick={() => setI((i - 1 + n) % n)} aria-label="Previous" className="w-12 h-12 rounded-full border border-espresso/25 flex items-center justify-center hover:bg-espresso hover:text-cream transition-colors duration-500">
              <ArrowLeft className="w-4 h-4" strokeWidth={1.4} />
            </button>
            <button data-testid="testimonial-next" onClick={() => setI((i + 1) % n)} aria-label="Next" className="w-12 h-12 rounded-full border border-espresso/25 flex items-center justify-center hover:bg-espresso hover:text-cream transition-colors duration-500">
              <ArrowRight className="w-4 h-4" strokeWidth={1.4} />
            </button>
            <span data-testid="testimonial-counter" className="text-sm text-mocha tracking-[0.2em] ml-2">{String(i + 1).padStart(2, "0")} / {String(n).padStart(2, "0")}</span>
          </div>
          <Link to="/reviews" data-testid="testimonials-all-reviews" className="link-u inline-block mt-8 text-[12px] uppercase tracking-[0.24em] pb-1">Read all reviews</Link>
        </Reveal>
        <div className="lg:col-span-9 relative min-h-[460px] sm:min-h-[400px] md:min-h-[340px]">
          <AnimatePresence initial={false}>
            <motion.figure
              key={i}
              data-testid="testimonial-active"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.9, ease: EASE }}
              className="absolute inset-0"
            >
              <p className="text-gold tracking-[0.3em] text-sm mb-6" aria-label="5 stars">★★★★★</p>
              <blockquote className="font-display font-light text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.18] text-espresso">“{t.q}”</blockquote>
              <figcaption className="mt-10 flex items-center gap-4">
                <span className="w-10 h-px bg-gold" />
                <span className="text-sm uppercase tracking-[0.24em]">{t.who}</span>
                <span className="text-sm text-mocha italic font-display text-lg">{t.occasion}</span>
              </figcaption>
            </motion.figure>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};
